// extracted by mini-css-extract-plugin
export var avatar = "_m2-3";
export var avatarContainer = "_m2-2";
export var avatarSpacer = "_m2-5";
export var avatarSpacerContainer = "_m2-4";
export var avatarStackContainer = "_m2-1";
export var bubble = "_m2-0";
export var remainderBubble = "_m2-6";